import { BoxV2 as Box, ButtonV2 as Button, Flex } from 'portal-commons';
import { FC } from 'react';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LoaSectionProps {
  fileName: string;
  onPreview?: () => void;
}

const LoaSection: FC<LoaSectionProps> = ({ fileName, onPreview }) => (
  <Flex
    sx={{
      alignItems: 'center',
      gap: 's',
      width: 'fit-content',
      p: '12px 14px',
      border: '1px solid #C0CCD4',
      borderRadius: '8px',
      background: '#F7F7FA',
    }}
  >
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        borderRadius: '6px',
        color: '#BF2626',
        background: '#FAE5E5',
      }}
    >
      <FontAwesomeIcon icon={faFileLines} />
    </Flex>
    <Box
      sx={{
        minWidth: '237px',
        color: '#171C26',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: 'normal',
      }}
    >
      {fileName}
    </Box>
    <Button
      style={{ background: '#FFF' }}
      shape="square"
      variant="outline"
      size="sm"
      onClick={onPreview}
    >
      Preview LOA
    </Button>
  </Flex>
);

export default LoaSection;
